import { Section } from '../components/Section';
import { Container } from '../components/Container';
import { Button } from '../components/Button';

const APP_STORE_URL = 'https://www.nuvemshop.com.br/loja-de-aplicativos/';

const features = [
  'Assinantes ilimitados',
  'Planos de assinatura ilimitados',
  'Widget na página do produto',
  'Portal do assinante',
  'Emails automáticos',
  'Métricas e relatórios',
  'Recuperação de pagamentos',
  'Suporte dedicado',
];

export function Pricing() {
  return (
    <Section background="gray">
      <Container maxWidth="content">
        <h2
          style={{
            fontSize: '24px',
            fontWeight: 800,
            fontFamily: 'var(--font-heading)',
            color: '#111827',
            textAlign: 'center',
            marginBottom: 'var(--spacing-xl)',
            lineHeight: 1.2,
          }}
        >
          Planos simples, sem surpresas
        </h2>

        <div className="pricing-card">
          {/* Left: plan info + CTA */}
          <div className="pricing-left">
            <div
              style={{
                fontSize: '14px',
                fontWeight: 600,
                color: '#A855F7',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
              }}
            >
              Assine
            </div>

            <div style={{ marginTop: 'var(--spacing-md)' }}>
              <span
                style={{
                  fontSize: '48px',
                  fontWeight: 800,
                  fontFamily: 'var(--font-heading)',
                  color: '#111827',
                  lineHeight: 1,
                }}
              >
                R$ 49
              </span>
              <span
                style={{
                  fontSize: '16px',
                  fontWeight: 400,
                  color: '#6b7280',
                }}
              >
                /mês
              </span>
            </div>

            <p
              style={{
                fontSize: '16px',
                fontWeight: 400,
                color: '#6b7280',
                marginTop: 'var(--spacing-md)',
                lineHeight: 1.5,
                maxWidth: 320,
              }}
            >
              Tudo que você precisa para vender por assinatura na sua loja Nuvemshop.
            </p>

            <div style={{ marginTop: 'var(--spacing-xl)' }}>
              <Button variant="gradient" href={APP_STORE_URL}>
                Começar agora
              </Button>
            </div>

            <p
              style={{
                fontSize: '14px',
                color: '#9ca3af',
                marginTop: 'var(--spacing-sm)',
              }}
            >
              Cancele quando quiser
            </p>
          </div>

          {/* Right: feature list */}
          <div className="pricing-right">
            <div
              style={{
                fontSize: '14px',
                fontWeight: 600,
                color: '#111827',
                marginBottom: 'var(--spacing-md)',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
              }}
            >
              Tudo incluso
            </div>

            <ul
              style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
                display: 'grid',
                gap: 'var(--spacing-sm)',
              }}
              className="feature-list"
            >
              {features.map((feature) => (
                <li
                  key={feature}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'var(--spacing-sm)',
                    fontSize: '16px',
                    color: '#111827',
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#A855F7"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ flexShrink: 0 }}
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Container>
      <style>{`
        .pricing-card {
          background: #ffffff;
          border: 1px solid #e5e7eb;
          border-radius: var(--radius);
          border-top: 3px solid #A855F7;
          padding: var(--spacing-2xl);
          display: flex;
          gap: var(--spacing-3xl);
          align-items: flex-start;
        }
        .pricing-left {
          flex: 1;
          min-width: 0;
        }
        .pricing-right {
          flex: 1;
          min-width: 0;
        }
        .feature-list {
          grid-template-columns: 1fr;
        }
        @media (min-width: 640px) {
          .feature-list {
            grid-template-columns: 1fr 1fr;
          }
        }
        @media (max-width: 767px) {
          .pricing-card {
            flex-direction: column;
            gap: var(--spacing-xl);
            padding: var(--spacing-lg);
          }
        }
      `}</style>
    </Section>
  );
}
